//Reducers
import generalReducer from './generalReducer';
import kpiReducer from './kpiReducer';
import productTypesReducer from './productTypesReducer';


export default {
    // general : generalReducer,
    product_types : productTypesReducer,
    kpi : kpiReducer,
};